module.exports = {
  "/": {
    "success": {
      "admin index": [
        "INDEX_LOAD"
      ],
      "public view": [
        "PREVIEW_LOAD"
      ],
      "document not found": [
        "DOCUMENT_NOT_FOUND"
      ]
    },
    "error": [
      "INDEX_FAIL",
      "PREVIEW_FAIL"
    ]
  },
  "/summary/:deckId": {
    "success": {
      "default": [
        "SUMMARY_LOAD"
      ]
    },
    "error": [
      "SUMMARY_FAIL"
    ]
  },
  "/preview/:presentationId": {
    "success": {
      "preview loaded": [
        "PREVIEW_LOAD"
      ],
      "document not found": [
        "DOCUMENT_NOT_FOUND"
      ],
      "document sharing permission incorrect": [
        "DOCUMENT_NO_PERMISSION"
      ]
    },
    "error": [
      "PREVIEW_FAIL"
    ]
  }
};